import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

// Layout and pages
import Layout from './layout/layout';
import LoginPage from './signup/signup';
import Dashboard from './Dashbord/dashbord';
import ViewLeads from './viewlist/viewlist';
import AddUser from './adduser/adduser';
import TemplatesPage from './components/pages/TemplatesPage';
import ProductCatalog from './products/ProductCatalog';
import MyProducts from './products/MyProducts';
import ProductForm from './products/ProductForm';
import Teams from './teams/Teams';
import TeamForm from './teams/TeamForm';
import Vendors from './components/Vendors';

// Template pages
import WhatsAppTemplates from './components/templates/WhatsAppTemplates';
import EmailTemplates from './components/templates/EmailTemplates';
import SmsTemplates from './components/templates/SmsTemplates';

const API_BASE = process.env.REACT_APP_API_URL;
function UserGameButton() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // User aur token changes ko track karein
  useEffect(() => {
    const checkUser = () => {
      const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
      const token = localStorage.getItem('token');
      
      setUser(storedUser);
      
      // Button show karein agar user exist karta hai aur role 'user' hai
      if (storedUser && storedUser.role === 'user' && token) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Initial check
    checkUser();

    // Storage events listen karein (tab change, login/logout)
    window.addEventListener('storage', checkUser);
    
    // Custom event for login/logout
    const handleAuthChange = () => checkUser();
    window.addEventListener('authChange', handleAuthChange);

    return () => {
      window.removeEventListener('storage', checkUser);
      window.removeEventListener('authChange', handleAuthChange);
    };
  }, []);

  // Agar visible nahi hai toh button hide karein
  if (!isVisible) {
    return null;
  }

  const handleOpenGame = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }

    setIsLoading(true);

    try {
      const endpoint = `${API_BASE}/auth/credexon-launch`;
      const res = await fetch(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      if (!res.ok || !data.launchUrl) {
        throw new Error(data.message || 'Unable to open game');
      }

      const newWindow = window.open(data.launchUrl, '_blank', 'noopener');
      
      if (!newWindow) {
        alert('Please allow pop-ups for this site to open the game.');
        return;
      }

    } catch (error) {
      console.error(error);
      alert('Game is not available right now. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleOpenGame}
      disabled={isLoading}
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '24px',
        zIndex: 9999,
        border: 'none',
        borderRadius: '999px',
        background: 'linear-gradient(135deg, #FF6B00, #8B5CF6)',
        color: '#fff',
        fontWeight: 700,
        fontSize: '14px',
        padding: '12px 22px',
        cursor: isLoading ? 'wait' : 'pointer',
        boxShadow: '0 12px 25px rgba(255, 107, 0, 0.35)',
        opacity: isLoading ? 0.6 : 1,
        transition: 'all 0.3s ease',
      }}
    >
      {isLoading ? '⏳ Loading...' : '🎮 Play & Win Rewards'}
    </button>
  );
}

function App() {
  return (
    <Router>
      <UserGameButton />
      <Routes>
        {/* Login */}
        <Route path="/" element={<LoginPage />} />

        {/* Routes inside Layout */}
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
        <Route path="/view-list" element={<Layout><ViewLeads /></Layout>} />
        <Route path="/add-user" element={<Layout><AddUser /></Layout>} />
        <Route path="/products" element={<Layout><ProductCatalog /></Layout>} />
        <Route path="/my-products" element={<Layout><MyProducts /></Layout>} />
        <Route path="/products/new" element={<Layout><ProductForm /></Layout>} />
        <Route path="/products/:id/edit" element={<Layout><ProductForm /></Layout>} />
        <Route path="/teams" element={<Layout><Teams /></Layout>} />
        <Route path="/teams/new" element={<Layout><TeamForm /></Layout>} />
        <Route path="/teams/:id/edit" element={<Layout><TeamForm /></Layout>} />
        <Route path="/templates" element={<Layout><TemplatesPage /></Layout>} />
        <Route path="/vendors" element={<Layout><Vendors /></Layout>} />

        {/* Individual template routes */}
        <Route path="/templates/whatsapp" element={<Layout><WhatsAppTemplates /></Layout>} />
        <Route path="/templates/email" element={<Layout><EmailTemplates /></Layout>} />
        <Route path="/templates/sms" element={<Layout><SmsTemplates /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
